export default class OrganizationSettingsManager {

    static isAttachmentsEnabled() {
        return gd.session.companies.get(gd.companyId).settings.modules.attachments
    }

    static isAttachmentsEnabledByProject(projectId: ID) {
        // if (!projectId) return false;
        // const companyId: ID =  gd.session.projects.get(projectId).companyId;

        return OrganizationSettingsManager.isAttachmentsEnabled()
    }

}
